import Vue from 'vue'

const toastr = {
  updateSuccess: () => {
    Vue.toasted.success('Data has been updated.', {icon: 'fa-check'})
  },
  addSuccess: () => {
    Vue.toasted.success('Data has been added.', {icon: 'fa-check'})
  },
  info: (text) => {
    Vue.toasted.info(text, {icon: 'fa-info-circle'})
  },
  error: (text) => {
    Vue.toasted.error(text, {icon: 'fa-exclamation-circle'})
  },
  serverError: () => {
    Vue.toasted.global.server_error()
  }
}

export default toastr
